import { useCallback, useEffect, useState } from 'react'

import { api } from 'app/api'
import { GET_COMPENSATION_TRANSACTIONS, convertResult, convertParams } from 'app/common/api/requests/cabinet/compensation/transactions/get'
import { TransactionsType } from 'app/dataTypes/cafeteria/compensation/transactions'
import SimpleDate from 'app/dataProviders/SimpleDate'


type Options = {
  studentID: string
  supplierID: string | null
  dateFrom: SimpleDate
  dateTo: SimpleDate
}

export function useCompensationTransactions(options: Options) {
  const { studentID, supplierID, dateFrom, dateTo } = options
  const [transactions, setTransactions] = useState<TransactionsType[]>([])
  const [loading, setLoading] = useState(true)

  const request = useCallback(async () => {
    setLoading(true)
    const res = await api.request(GET_COMPENSATION_TRANSACTIONS, {
      error: 'Не удалось получить историю операций по компенсациям',
      params: {
        studentID,
        supplierID: supplierID ?? '',
        dateFrom,
        dateTo,
      },
      convertions: {
        convertParams,
        convertResult,
      },
    })

    setLoading(false)
    if (res) {
      setTransactions(res)
    }
  }, [studentID, supplierID, dateFrom, dateTo])

  useEffect(() => {
    if (supplierID) {
      request()
    }
  }, [request, studentID, supplierID, dateFrom, dateTo])


  return {
    transactions,
    loading,
  }
}
